import React, { useState, useEffect, useMemo, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL";
import "./overviewdashboard.css";
import "./datepicker.css";
import CountUp from "react-countup";
import { FaInfoCircle } from "react-icons/fa";
import "./datepicker.css"


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { 
  FaPercentage,
  FaDownload,
  FaCalendarAlt,
  FaSync
} from "react-icons/fa";

const StockToNormDashboard = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [rowData, setRowData] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [locationNames, setLocationNames] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [apiData, setApiData] = useState(null);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [stockToNormPercentage, setStockToNormPercentage] = useState(0);
  const [highlightedDates, setHighlightedDates] = useState([]);

  
  const isApplyDisabled = selectedLocations.length === 0 || selectedCategories.length === 0;

  const datePickerRef = useRef(null);
  
  const CustomHeader = (props) => {
    const tooltip = props?.column?.getColDef()?.headerTooltip || "";
    const [showMenu, setShowMenu] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onMenuClick = (event) => {
      props.showColumnMenu(event.currentTarget);
    };

    const onSortRequested = (order, event) => {
      props.setSort(order, event?.shiftKey);
    };

    const getSort = () => {
      return props.column.getSort();
    };

    const isSortable = props.column.getColDef().sortable;

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
        onMouseEnter={() => setShowMenu(true)}
        onMouseLeave={() => setShowMenu(false)}
      >
        <span
          style={{
            cursor: isSortable ? "pointer" : "default",
            userSelect: "none"
          }}
          onClick={isSortable ? () => {
            const currentSort = getSort();
            let newSort = 'asc';
            if (currentSort === 'asc') newSort = 'desc';
            else if (currentSort === 'desc') newSort = null;
            onSortRequested(newSort, null);
          } : undefined}
        >
          {props.displayName}
        </span>

        {isSortable && (
          <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'asc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('asc', null)}
            >
              ↑
            </span>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'desc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('desc', null)}
            >
              ↓
            </span>
          </div>
        )}

        <div
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

          {showTooltip && tooltip && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                zIndex: 1000,
                marginTop: "5px",
              }}
            >
              {tooltip}
            </div>
          )}
        </div>

        {props.enableMenu && (
          <span
            onClick={onMenuClick}
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              fontSize: 14,
              opacity: showMenu ? 1 : 0,
              transition: "opacity 0.2s ease",
            }}
          >
            ☰
          </span>
        )}
      </div>
    );
  };

  const columnDefs = useMemo(() => [
    { 
      field: "destination_store_id", 
      headerName: "Destination Store ID", 
      minWidth: 150,
      filter: true 
    },
    { 
      field: "destination_store_name", 
      headerName: "Destination Store Name", 
      minWidth: 180,
      filter: true 
    },
    { 
      field: "destination_type", 
      headerName: "Type", 
      minWidth: 120,
      filter: true 
    },
    { 
      field: "sku_code", 
      headerName: "SKU Code", 
      width: 120,
      filter: true 
    },
    { 
      field: "sku_name", 
      headerName: "SKU Name", 
      minWidth: 300,
      filter: true 
    },
    { 
      field: "sku_category", 
      headerName: "Category", 
      minWidth: 150,
      filter: true 
    },
    { 
      field: "current_stock", 
      headerName: "Current Stock", 
      minWidth: 130,
    },
    { 
      field: "stn", 
      headerName: "STN", 
      minWidth: 100,
     
    },
    { 
      field: "stock_to_norm", 
      headerName: "Stock-to-Norm %", 
      minWidth: 150,
      valueFormatter: params => params.value
    },
    { 
      field: "min_stn", 
      headerName: "Min STN", 
      minWidth: 100,
    
    },
    { 
      field: "mstn_percentage", 
      headerName: "MSTN %", 
      minWidth: 120,
      valueFormatter: params => params.value 
    }
  ], []);

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      minWidth: 100,
      cellStyle: { fontSize: '13px' }
    }),
    []
  );
       const getHighlightedDates = async () => {  
      try {
        const response = await redirectURL.post("inventory/getdarkstoredates", {});
        if (response.status === 200 && response.data.dates) {
          const dates = response.data.dates.map(dateStr => {
            try {
              return new Date(dateStr);
            } catch (e) {
              return null;
            }
          }).filter(date => date !== null);
          setHighlightedDates(dates);
        }
      } catch (error) {
        console.error("Failed to fetch highlighted dates:", error);
      }
    }


  const fetchLocationOptions = async () => {
    try {
      const resp = await redirectURL.post("inventory/getlocationData");
      
      if (resp && resp.data && resp.data.status === "success") {
        const locations = resp.data.data || [];

        const darkStores = locations.filter(location => 
          (location.is_active === 1 || location.is_active === 0) && 
          location.destination_store_id !== "MWH01"
        );
        
        darkStores.sort((a, b) => a.destination_store_id.localeCompare(b.destination_store_id));
        
        const locationOptionsArr = darkStores.map(loc => ({
          label: `${loc.destination_store_id} - ${loc.destination_store_name}`,
          value: loc.destination_store_id
        }));
        
        const locationNamesMapping = {};
        darkStores.forEach(loc => {
          locationNamesMapping[loc.destination_store_id] = `${loc.destination_store_id} - ${loc.destination_store_name}`;
        });
        
        setLocationOptions(locationOptionsArr);
        setLocationNames(locationNamesMapping);
        
        if (locationOptionsArr.length > 0) {
          const allLocationValues = locationOptionsArr.map(option => option.value);
          setSelectedLocations(allLocationValues);
        }
      } else {
        console.error("Failed to fetch location options");
        const defaultLocations = [{
          label: "D007 - Bangalore DS 1",
          value: "D007"
        }];
        setLocationOptions(defaultLocations);
        setLocationNames({
          "D007": "D007 - Bangalore DS 1",
        });
        setSelectedLocations(["D007"]);
      }
    } catch (error) {
      console.error("Error fetching location options:", error);
      const defaultLocations = [{
        label: "D007 - Bangalore DS 1",
        value: "D007"
      }];
      setLocationOptions(defaultLocations);
      setLocationNames({
        "D007": "D007 - Bangalore DS 1",
      });
      setSelectedLocations(["D007"]);
    }
  };

  const fetchCategoryOptions = async () => {
    try {
      const resp = await redirectURL.post("inventory/getSKUCategories");
      
      if (resp && resp.data && resp.data.status === "success") {
        const categories = resp.data.categories || [];
        
        const categoryOptionsArr = categories.map(cat => ({
          label: cat,
          value: cat
        }));
        
        setCategoryOptions(categoryOptionsArr);
        
        if (categories.length > 0) {
          const allCategoryValues = categories;
          setSelectedCategories(allCategoryValues);
        }
        
      } else {
        console.error("Failed to fetch category options");
        setCategoryOptions([]);
        setSelectedCategories([]);
      }
    } catch (error) {
      console.error("Error fetching category options:", error);
      setCategoryOptions([]);
      setSelectedCategories([]);
    }
  };

  const fetchStockToNormData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    try {
      setHasAnimated(false);
      
      const formattedDate = selectedDate ? selectedDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
      
      const payload = { 
        date: formattedDate,
        location: selectedLocations,
        category: selectedCategories 
      };
      
      const resp = await redirectURL.post("inventory/InventoryAnalyticsDashboardNew", payload);    
      
      if (resp && resp.data) {
        if (resp.data.status === "Success") {
          const data = resp.data.data || {};
          setApiData(data);
          
          // Set stock-to-norm percentage
          setStockToNormPercentage(data.stock_to_norm_percentage || 0);
          
          // Parse the stock_to_norm_data if it's a string
          let stockToNormData = [];
          if (data.stock_to_norm_data) {
            if (typeof data.stock_to_norm_data === 'string') {
              try {
                stockToNormData = JSON.parse(data.stock_to_norm_data);
              } catch (error) {
                console.error("Error parsing stock_to_norm_data:", error);
                stockToNormData = [];
              }
            } else {
              stockToNormData = data.stock_to_norm_data;
            }
          }
          
          setRowData(stockToNormData);
          
          // Clear any error message on success
          setBasicTitle("");
          setShow(false);
          
        } else if (resp.data.status === "Failure") {
          setBasicTitle(resp.data.message || "Failed to fetch stock-to-norm data");
          setBasicType("error");
          setShow(true);

          setApiData(null);
          setRowData([]);
          setStockToNormPercentage(0);
        } else {
          setBasicTitle("Invalid response from server");
          setBasicType("error");
          setShow(true);
        }
      } else {
        setBasicTitle("No response from server");
        setBasicType("error");
        setShow(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setBasicTitle(error.response?.data?.message || error.message || "Failed to fetch stock-to-norm data");
      setBasicType("error");
      setShow(true);
    } finally {
      setTimeout(() => {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setHasAnimated(true);
      }, 500);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
    } else {
      setSelectedDate(new Date());
    }
  };

  const handleExport = () => {
    if (window.gridApi) {
      const formattedDate = selectedDate ? selectedDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
      const locationLabel = selectedLocations.length === locationOptions.length ? "All" : selectedLocations.join("_");
      const categoryLabel = selectedCategories.length === categoryOptions.length ? "All" : selectedCategories.join("_");
      const params = {
        fileName: `stock_to_norm_${locationLabel}_${formattedDate}_${categoryLabel}.csv`
      };
      window.gridApi.exportDataAsCsv(params);
    }
  };

  const handleApply = () => {
    fetchStockToNormData();
  };

  const onGridReady = (params) => {
    window.gridApi = params.api;
    params.api.sizeColumnsToFit();
  };
  
  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);
  
  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDatePicker && datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDatePicker]);

  useEffect(() => {
    fetchLocationOptions();
    fetchCategoryOptions();
    getHighlightedDates();
  }, []);

  useEffect(() => {
    if (locationOptions.length > 0 && categoryOptions.length > 0) {
      fetchStockToNormData();
    }
  }, [locationOptions, categoryOptions]);

  const formatNumber = (num) => {
    if (typeof num !== 'number') return '0';
    return num.toLocaleString('en-IN');
  };

  const formatDisplayDate = (date) => {
    if (!date) return new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getTotalSKUs = () => {
    return rowData.length || 0;
  };

  const getPercentageColor = (percentage) => {
    if (percentage < 80) return '#dc3545'; // Red for low
    if (percentage < 100) return '#ffc107'; // Yellow for moderate
    if (percentage < 120) return '#28a745'; // Green for good
    return '#6f42c1'; // Purple for excellent
  };

  return (
    <>
      <div className="dashboard-container">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={() => setShow(false)}
          />
        </div>
        
        {/* Dashboard Header */}
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Stock-to-Norm</h1>
            <p className="header-left">Inventory Performance Analysis</p>
          </div>

          <div className="header-right">
            {/* Destination Store - MultiSelect */}
            <div className="filter-container multi-select-container">
              <div className="filter-title">Destination Store :</div>
              <div className="multi-select-wrapper">
                <MultiSelect
                  value={selectedLocations}
                  options={locationOptions}
                  onChange={(e) => setSelectedLocations(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  filter
                  maxSelectedLabels={1}
                  display="chip"
                  placeholder="Select destinations"
                  style={{
                    width: "100%",
                    borderRadius: "5px",
                    backgroundColor: "#fff",
                    fontSize: "13px",
                  }}
                />
              </div>
            </div>

            {/* Category - MultiSelect */}
            <div className="filter-container multi-select-container">
              <div className="filter-title">Category :</div>
              <div className="multi-select-wrapper">
                <MultiSelect
                  value={selectedCategories}
                  options={categoryOptions}
                  onChange={(e) => setSelectedCategories(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  filter
                  maxSelectedLabels={1}
                  display="chip"
                  placeholder="Select categories"
                  style={{
                    width: "100%",
                    borderRadius: "5px",
                    backgroundColor: "#fff",
                    fontSize: "13px",
                  }}
                />
              </div>
            </div>

            {/* Date */}
            <div className="filter-container datepicker-container" ref={datePickerRef}>
              <div className="filter-title">Date :</div>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
                      highlightDates={highlightedDates}

                wrapperClassName="date-picker-wrapper"
                customInput={
                  <div className="filter-select datepicker-input">
                    <FaCalendarAlt className="filter-icon" />
                    <span className="filter-label">
                      {formatDisplayDate(selectedDate)}
                    </span>
                  </div>
                }
              />
            </div>

            {/* Apply */}
            <button
              className="btn-refresh"
              onClick={handleApply}
              disabled={isApplyDisabled}
              style={{
                cursor: isApplyDisabled ? "not-allowed" : "pointer",
                opacity: isApplyDisabled ? 0.6 : 1
              }}
            >
               Apply
            </button>
          </div>
        </div>

        {/* Single Counter Card */}
        {/* <div className="overview-container-doc-stats">
          <div 
            className="doc-stat-card" 
            style={{ 
              borderLeft: `4px solid ${getPercentageColor(stockToNormPercentage)}`,
              gridColumn: "span 2",
              display: "flex",
              width:"403px",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px 30px"
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div 
                className="doc-stat-icon" 
                style={{ 
                  color: getPercentageColor(stockToNormPercentage),
                  fontSize: "36px"
                }}
              >
                <FaPercentage />
              </div>
              
              <div className="doc-stat-content">
                <div className="doc-stat-count" style={{ fontSize: "32px" }}>
                  {hasAnimated ? (
                    <span>{stockToNormPercentage.toFixed(1)}%</span>
                  ) : (
                    <CountUp 
                      start={0} 
                      end={stockToNormPercentage} 
                      duration={1}
                      decimals={1}
                      suffix="%"
                    />
                  )}
                </div>
                <div className="doc-stat-label" style={{ fontSize: "16px", fontWeight: "600" }}>
                  Overall Stock-to-Norm Percentage
                </div>
                <div className="doc-stat-description" style={{ fontSize: "14px" }}>
                  Average across all SKUs ({getTotalSKUs()} SKUs analyzed)
                </div>
              </div>
            </div>

            
          </div>
        </div> */}
       

        {/* Stock-to-Norm Table */}
        <div className="inventory-table-container">
          <div className="table-header">
            <h3>
              {/* Stock-to-Norm Analysis ({getTotalSKUs()} SKUs) */}
                            Stock-to-Norm SKUs

            </h3>
            {/* <div className="table-actions">
              <button className="btn-export" onClick={handleExport}>
                <FaDownload /> Export
              </button>
            </div> */}
          </div>
          <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              sideBar={sideBar}
              statusBar={statusPanel}
              enableRangeSelection={true}
              overlayNoRowsTemplate="No stock-to-norm data available"
            />
          </div>
        </div>
      </div>

      {/* Loader and overlay */}
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
    </>
  );
};

export default StockToNormDashboard;